module.exports = __webpack_public_path__ + "static/nums-illustration-af7857690cb7e180fd31123249ca526e.png";